import { Semanticpmpmvt7fldq2 as Semantic } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  applyAlpha3k2fcxahu1lgz as applyAlpha,
  Companion_getInstancenv8qpb0wanrh as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SeparatorSemanticClass;
function SeparatorSemantic() {
  if (SeparatorSemanticClass === VOID) {
    class $ extends Semantic() {
      static ijs() {
        SeparatorSemantic_instance = null;
        var $this = this.bd1('sep');
        SeparatorSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, equals(theme.ob0_1, Companion_getInstance().raz_1) ? AppColors_getInstance().ffz_1.yg9_1 : applyAlpha(theme.jb0_1, 0.4));
      }
      toString() {
        return 'SeparatorSemantic';
      }
      hashCode() {
        return -695148071;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SeparatorSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SeparatorSemantic');
    SeparatorSemanticClass = $;
  }
  return SeparatorSemanticClass;
}
var SeparatorSemantic_instance;
function SeparatorSemantic_getInstance() {
  if (SeparatorSemantic_instance === VOID)
    SeparatorSemantic().ijs();
  return SeparatorSemantic_instance;
}
function greySeparator(_this__u8e3s4, setup) {
  var tmp;
  if (setup === VOID) {
    tmp = greySeparator$lambda;
  } else {
    tmp = setup;
  }
  setup = tmp;
  _this__u8e3s4.hbb(SeparatorSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Separator())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  setup(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function greySeparator$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  greySeparator as greySeparatory5mpcoeivng5,
};
//endregion

//# sourceMappingURL=separators.mjs.map
